// assets
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';

// constant
const icons = {
  GroupRoundedIcon
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const user_management = {
  id: 'user-management',
  title: 'User Management',
  // caption: 'Pages Caption',
  type: 'group',
  userRoles: ['Super Admin'],
  children: [
    {
      check:'view-users',
      id: 'app-users-list',
      title: 'Users',
      type: 'item',
      url: '/app-users-list',
      icon: icons.GroupRoundedIcon,
      breadcrumbs: false
    },
    {
      check:'view-sellers',
      id: 'sellers',
      title: 'Sellers',
      type: 'item',
      url: '/sellers',
      showCount: true,
      apiUrl:`${process.env.REACT_APP_APIPATH}/sellers/pending-seller-count/`,
      icon: icons.GroupRoundedIcon,
      breadcrumbs: false
    }
  ]
};

export default user_management;
